/**
 * Estado da SESSÃO DE PROCESSO do `ReadingThemeAutoWatcher` — memória do
 * módulo, não `localStorage`: o teto e a histerese valem até o app fechar, e
 * reabrir é justamente o gatilho 1 (`docs/systems/reading-theme-auto.md` §2.3).
 */
export const readingThemeAutoSession = {
  booted: false,
  regens: 0,
  attempted: new Set<string>(),
  baseline: new Map<string, number>(),
  prevStatuses: null as Map<string, string> | null,
  inFlight: false,
};

/** Só para teste. */
export function resetReadingThemeAutoSession(): void {
  const s = readingThemeAutoSession;
  s.booted = false;
  s.regens = 0;
  s.attempted.clear();
  s.baseline.clear();
  s.prevStatuses = null;
  s.inFlight = false;
}
